import i18next from 'i18next';

i18next.addResources('es_CL', 'Printer', {
  printers: 'Impresoras',
  printerHelperText: 'Selecciona una impresora',
  enable: 'Habilitar impresión automática',
  success: 'Conectado',
  error: 'Desconectado',
  warning: 'Impresora {{printer}} desconectada'
});

i18next.addResources('es_CR', 'Printer', {
  printers: 'Impresoras',
  printerHelperText: 'Selecciona una impresora',
  enable: 'Habilitar impresión automática',
  success: 'Conectado',
  error: 'Desconectado',
  warning: 'Impresora {{printer}} desconectada'
});
